"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_sortable_hoc_1 = require("react-sortable-hoc");

var react_1 = __importDefault(require("react"));

var re_resizable_1 = __importDefault(require("re-resizable"));

var ENABLED_DRAG_SIDES = {
  top: false,
  right: true,
  bottom: false,
  left: false,
  topRight: false,
  bottomRight: false,
  bottomLeft: false,
  topLeft: false
};
var defaultUI = {
  DragHandle: 'span',
  ResizeHandle: 'div',
  Reresizable: re_resizable_1.default
};

var getUI = function getUI(ui) {
  if (ui === void 0) {
    ui = {};
  }

  return __assign(__assign({}, defaultUI), ui);
};

var Handle = react_sortable_hoc_1.SortableHandle(function (_a) {
  var Component = _a.component,
      rest = __rest(_a, ["component"]);

  return react_1.default.createElement(Component, __assign({}, rest));
});
var SortableResizableWrapper = react_sortable_hoc_1.SortableElement(function (props) {
  var isEnabled = props.isEnabled,
      children = props.children,
      className = props.className,
      ui = props.ui,
      resizableProps = __rest(props, ["isEnabled", "children", "className", "ui"]);

  var _a = getUI(ui),
      DragHandle = _a.DragHandle,
      ResizeHandle = _a.ResizeHandle,
      Reresizable = _a.Reresizable;

  var childrenWithDragHandle = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Handle, {
    component: DragHandle,
    style: {
      display: isEnabled ? 'block' : 'none'
    }
  }), children);
  return react_1.default.createElement(Reresizable, __assign({
    enable: ENABLED_DRAG_SIDES,
    isEnabled: isEnabled,
    scale: 1,
    className: className,
    handleComponent: {
      right: ResizeHandle
    }
  }, resizableProps), childrenWithDragHandle);
});
SortableResizableWrapper.defaultProps = {
  className: '',
  onClick: function onClick() {},
  onResize: function onResize() {},
  defaultSize: {
    width: '',
    height: ''
  },
  isEnabled: true
};
exports.default = SortableResizableWrapper;